// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FormatItalicIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FormatItalicIcon" ref={forwardedRef} {...props}>
      <path d="M7.583 3.5H16l-.601 1.51h-3.315L9.42 14.99h3.598l-.602 1.51H4l.6-1.51h3.265l2.663-9.98H6.982z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const FormatItalicIcon = /* @__PURE__ */ Object.assign(
  FormatItalicIconComponent,
  { displayName: 'FormatItalicIcon' },
);
